import { Component, OnChanges, Input } from '@angular/core';
import { DSPDayToken, DailyDeliveryPlan } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
@Component({
  selector: 'app-daily-dlvry-pln',
  templateUrl: './daily-dlvry-pln.component.html',
  styleUrls: ['./daily-dlvry-pln.component.css']
})
export class DailyDlvryPlnComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() dlyDlvryPln:DailyDeliveryPlan;  
  dDSPDayTokenObj:DSPDayToken;

  constructor(private _dataService:DataService) { }

  ngOnChanges() {
    this.loadDateData();
  }

  loadDateData():void{
    if(this.dlyDlvryPln){
      let _tmpDPHDayToken:DSPDayToken = this.dlyDlvryPln.getDateToken(this.currMonthDtObj);
        if(_tmpDPHDayToken == null){
          this.dlyDlvryPln.addDateToken(this.currMonthDtObj);  
          _tmpDPHDayToken = this.dlyDlvryPln.getDateToken(this.currMonthDtObj);
        }
        this.dDSPDayTokenObj = _tmpDPHDayToken;
    }
    else{
      this.dDSPDayTokenObj = new DSPDayToken(this.currMonthDtObj,[])
    }    
  }
  formatDate(_date:Date):string{
    if(_date){      
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  getData(option){
    if(option){
      return option
    }
    return ''
 }
 getProductData(_productId:string):string{
   if(_productId){
     return this._dataService.getProductName(_productId)
   }
   return ''
 }
 getCustomerName(_custId:string):string{
   if(_custId)
     return this._dataService.getCustomerName(_custId);
   return '';
 }
 getMainProduct(type:string):string{
   if(type){
     return this._dataService.getProductType(type);
   }
   return ''
 }
 getResponsiblePrsn(_prsn:string):string{
   if(_prsn) return this._dataService.getResponsiblePrsn(_prsn);
   return ''
 }
 getTypeReady(_id:string):string{
   if(_id) return this._dataService.getTypeReady(_id)
   return ''
 }
 getTypeAvailable(_id:string):string{
   if(_id) return this._dataService.getTypeAvailable(_id)
   return ''
 }
 getTypeStructure(_id:string):string{
   if(_id) return this._dataService.getTypeStructure(_id)
   return ''
 }
}
